import { render, staticRenderFns } from "./AddAddressView.vue?vue&type=template&id=61c03b70"
import script from "./AddAddressView.vue?vue&type=script&lang=js"
export * from "./AddAddressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports